import { FC, ReactElement } from 'react';

import { Wrapper } from '../../../components';
import { ProductCategory } from '../../../entities/@products/ProductCategory/ProductCategory';
import { Link } from '../../../entities/Link/Link';
import { Space } from '../../../entities/Space/Space';
import { useTrans } from '../../../hooks';
import { CategorySlider } from '../..';
import { Breadcrumbs } from '../../Breadcrumbs/Breadcrumbs';
import { SpaceDetailRendererSkeletons } from './skeletons';
import { SpaceDetailHelmet } from './subcomponents';

import './SpaceDetailRenderer.scss';

interface SpaceDetailRendererProps {
    isLoading: boolean;
    space?: Space;
    showSlider: boolean;
    categories: ProductCategory[];
    breadcrumbs: Link[];
    className?: string;
}

export const SpaceDetailRenderer: FC<SpaceDetailRendererProps> = ({
    isLoading,
    space,
    showSlider,
    categories,
    breadcrumbs,
    className = '',
}): ReactElement => {
    const trans = useTrans();

    if (isLoading) {
        return (
            <SpaceDetailRendererSkeletons />
        );
    }

    return (
        <div className={`space-detail-renderer ${className}`}>
            {space && (
                <SpaceDetailHelmet space={space} />
            )}

            <Wrapper>
                <Breadcrumbs
                    breadcrumbs={breadcrumbs}
                    className="space-detail-renderer__breadcrumbs"
                />
            </Wrapper>

            {!showSlider && space && (
                <Wrapper className={`space-detail-renderer ${className}`}>
                    <h1 className="space-detail-renderer__heading">
                        {space.title}
                    </h1>
                </Wrapper>
            )}

            {showSlider && space && (
                <CategorySlider
                    categories={categories}
                    title={space.title || trans('containers.spaceDetailRenderer.sliderFallbackTitle', { space: space.name })}
                    className="space-detail-renderer__category-slider"
                />
            )}
        </div>
    );
};
